export const SUBMENU_OFFSET_MAIN_AXIS = 12;
export const SUBMENU_OFFSET_CROSS_AXIS = -60;
